<panel [panelInput]="panelConfig" (close)="cancel()">
  <div class="primary-info-container --borderless flex-row justify-content-between">
    <ul class="ds-info-text --icon-ai --info">
      <li>
        <span class="title-14">{{ "smart_import_ai_page_review" | translate }}</span>
        <p class="paragraph-12">
          {{ "smart_import_page_review_summary" | translate: { pages: analysisResult?.totalPages, groups: totalGroups } }}
        </p>
      </li>
    </ul>
    <ds-button [buttonInput]="aiAcceptButtonConfig" (btnClick)="acceptAllHighConfidence()"></ds-button>
  </div>

  <div class="import-cc-pdf_container">
    <div class="page-type_container">
      <div class="page-type-title">
        <p class="paragraph-12">{{ "smart_import_pages_by_types" | translate: { count: totalGroups } }}</p>
      </div>
      <div class="page-type-list">
        @for (group of groups; track group.id) {
        <div class="page-type-item" [class.selected]="group.id === selectedGroupId" (click)="selectGroup(group.id)">
          <div class="form-check ds-eod-radio ds-eod-radio--md">
            @if (isClassified(group)) {
            <img [src]="ICONS.ICON_TICK" alt="" class="si-rail__classified-icon" />
            } @else {
            <input class="form-check-input is-primary" type="radio" name="pageType" [id]="'pageType' + group.id"
              [checked]="group.id === selectedGroupId" (change)="selectGroup(group.id)" />
            }
            <label class="form-check-label" [attr.for]="'pageType' + group.id">
              <p class="label-text">
                {{ group.contentTypeLabel }}
                @if (isFlagged(group) && !group.action) {
                <img [src]="ICONS.WARNING" alt="" [title]="'smart_import_needs_review' | translate"
                  class="si-rail__flag-icon" />
                }
              </p>
              <p class="helper-text">
                @if (group.pageNumbers.length === 1) {
                {{ "smart_import_page_single" | translate: { count: group.pageNumbers.length } }}
                } @else {
                {{ "smart_import_n_pages" | translate: { count: group.pageNumbers.length } }}
                }
              </p>
            </label>
          </div>
          <div class="--status" [ngClass]="statusClassFor(group)">
            <img [src]="ICONS.BULLET" alt="" /> {{ statusLabelKeyFor(group) | translate }}
          </div>
        </div>
        }
      </div>
    </div>

    <div class="cardholder_container">
      @if (selectedGroup) {
      <div class="cardholder-header">
        <div>
          <h6 class="cardholder-title">
            {{ selectedGroup.contentTypeLabel }}
          </h6>
          <p class="cardholder-subtitle">{{ selectedGroup.descriptionText }}</p>
        </div>
        <div class="--status gap-8" [ngClass]="confidenceStatusClass(selectedGroup)">
          <img [src]="confidenceIcon(selectedGroup)" alt="" /> {{ selectedGroup.confidence }}% {{
          "smart_import_confidence" | translate }}
        </div>
      </div>

      <div class="cardholder-image-body">
        @if (fileUrl && miniPreviewVisible) {
        @if (previewLoading) {
        <span class="si-viewer-loading">
          <span class="si-spinner"></span>
        </span>
        }
        <ngx-extended-pdf-viewer [src]="fileUrl" [page]="previewPageNumber" height="100%" class="w-100pc h-100"
          [showToolbar]="false" [showSidebarButton]="false" [showFindButton]="false" [showPagingButtons]="false"
          [showZoomButtons]="false" [showPresentationModeButton]="false" [showOpenFileButton]="false"
          [showPrintButton]="false" [showDownloadButton]="false" [showBookmarkButton]="false"
          [showSecondaryToolbarButton]="false" [showRotateButton]="false" [showHandToolButton]="false"
          [showDrawEditor]="false" [showTextEditor]="false" (pdfLoadingStarts)="onPreviewLoadingStarts()"
          (pdfLoaded)="onPreviewLoaded()"></ngx-extended-pdf-viewer>
        } @else {
        <img [src]="ICONS.FILE_TEXT" alt="" />
        }

        <div class="--status --secondary no-bullet">
          {{ "smart_import_showing_page" | translate: { page: previewPageIndex + 1, count: selectedGroup.pageCount } }}
        </div>

        <button type="button" class="full-screen-btn" (click)="openReader()">
          <img [src]="ICONS.MAXIMIZE" alt="" /> {{ "smart_import_view_full_screen" | translate }}
        </button>

        @if (miniPreviewVisible) {
        <button type="button" class="left-arrow" [disabled]="isPreviewFirstPage" (click)="prevPreviewPage()">
          <img [src]="ICONS.CHEVRON_LEFT" alt="" />
        </button>
        <button type="button" class="right-arrow" [disabled]="isPreviewLastPage" (click)="nextPreviewPage()">
          <img [src]="ICONS.CHEVRON_RIGHT" alt="" />
        </button>
        }
      </div>

      <div class="d-flex justify-content-center flex-column gap-8">
        <p class="w-95pc mx-auto paragraph-12">{{ "smart_import_choose_option" | translate }}</p>
        <div class="d-flex justify-content-center align-items-center gap-12 w-95pc mx-auto">
          @for (card of actionCards; track card.action) {
          <div class="w-100pc flex-row justify-content-between align-items-center" [ngClass]="card.containerClass">
            <ds-radio-button [items]="card.radio" (selectedChange)="onActionSelected(card.action)"></ds-radio-button>
            @if (card.aiSuggested) {
            <ul class="ds-info-text --icon-ai --ai-primary --text-ai-primary">
              <li>{{ "smart_import_ai_suggested_badge" | translate }}</li>
            </ul>
            }
          </div>
          }
        </div>
        <div class="eod-checkbox eod-checkbox--md form-check mx-auto">
          <input type="checkbox" class="form-check-input is-primary" [id]="'remember-' + selectedGroup.id"
            [checked]="selectedGroup.rememberRule ?? true" (change)="toggleRemember(selectedGroup)" />
          <label class="form-check-label" [attr.for]="'remember-' + selectedGroup.id">
            <p class="label-text"
              [innerHTML]="'smart_import_remember_decision' | translate: { group: selectedGroup.contentTypeLabel, organisation: organisationName }">
            </p>
          </label>
        </div>
      </div>
      }
    </div>
  </div>

  <ng-container panel-footer>
    <div class="d-flex align-items-center gap-16 w-60pc">
      <p><img class="icon-success" [src]="ICONS.BULLET" alt="" />
        <span [innerHTML]="'smart_import_importing_n_pages' | translate: { count: importingPages }"></span>
      </p>
      <p><img class="icon-warning" [src]="ICONS.BULLET" alt="" />
        <span [innerHTML]="'smart_import_skipping_n_pages' | translate: { count: skippingPages }"></span>
      </p>
      <p><img class="icon-error" [src]="ICONS.BULLET" alt="" />
        <span [innerHTML]="'smart_import_never_import_n_pages' | translate: { count: neverImportPages }"></span>
      </p>
    </div>
    <div  class="d-flex align-items-center gap-16 w-40pc justify-content-end">
      <p class="text-right">
        @if (submitError) {
        <span class="text-error">{{ "smart_import_retry_banner" | translate }}</span>
        } @else if (allReviewed) {
        {{ "smart_import_all_reviewed" | translate }}
        } @else {
        {{ "smart_import_n_groups_need_review" | translate: { count: totalGroups - reviewedCount } }}
        }
      </p>
      <button type="button" class="btn btn-primary btn-primary--lg" [disabled]="!allReviewed || submitting"
        (click)="submitImportAndScan()">
        {{ "smart_import_proceed" | translate }}
      </button>
    </div>
  </ng-container>
</panel>

@if (readerOpen && selectedGroup) {
<smart-import-reader [group]="selectedGroup" [fileUrl]="fileUrl" [pageIndex]="readerPageIndex"
  (pageIndexChange)="readerPageIndex = $event" (closed)="closeReader()"></smart-import-reader>
}
@if (showAcceptSuggestionsModal) {
<smart-import-accept-suggestions [groups]="eligibleForBulkAccept" [remainingCount]="remainingAfterAcceptCount"
  (confirmed)="confirmAcceptSuggestions()" (cancelled)="cancelAcceptSuggestions()"></smart-import-accept-suggestions>
}